function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "e-apm\\u0101c\\u012Bba",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "01.-Kopsavilkums",
  transform: "translate(-30.000000, -399.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 202.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu-item-4",
  transform: "translate(0.000000, 183.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon",
  transform: "translate(30.000000, 14.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon-base",
  x: 0,
  y: 0,
  width: 22,
  height: 22,
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M20,2 C21.0543618,2 21.9181651,2.81587779 21.9945143,3.85073766 L22,4 L22,18 C22,19.0543618 21.1841222,19.9181651 20.1492623,19.9945143 L20,20 L2,20 C0.945638205,20 0.0818348781,19.1841222 0.00548573643,18.1492623 L0,18 L0,4 C0,2.9456382 0.815877791,2.08183488 1.85073766,2.00548574 L2,2 L20,2 Z M20,9 L2,9 L2,18 L20,18 L20,9 Z M5,14 C5.55228475,14 6,14.4477153 6,15 C6,15.5522847 5.55228475,16 5,16 C4.44771525,16 4,15.5522847 4,15 C4,14.4477153 4.44771525,14 5,14 Z M8,14 C8.55228475,14 9,14.4477153 9,15 C9,15.5522847 8.55228475,16 8,16 C7.44771525,16 7,15.5522847 7,15 C7,14.4477153 7.44771525,14 8,14 Z M20,4 L2,4 L2,7 L20,7 L20,4 Z",
  id: "icon",
  fill: "#667380",
  fillRule: "nonzero"
}))))));

function SvgIcSidenavPayments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B966E308-5BE2-4DED-B038-2A9F71E01D87") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSidenavPayments);
export default __webpack_public_path__ + "static/media/ic-sidenav-payments.942f24c3.svg";
export { ForwardRef as ReactComponent };